import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import GenericCard from './GenericCard.vue';
import { instance as api } from '@/helpers/api';


export default /*#__PURE__*/_defineComponent({
  __name: 'NeuanmeldungenBenutzerCard',
  setup(__props) {

const counter = ref(0);

onMounted(async () => {
    try {
        const res = await api().get('/RequestedUser/countRegistered');
        if (res?.data?.count) {
            counter.value = Number(res.data.count);
        } else {
            counter.value = 0;
        }
    } catch (e) {
        counter.value = 0;
    }
});

return { __sfc: true,counter, GenericCard }
}

})